<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <div v-show="status && status !== 'PAID'">
            <div v-if="hasPermission('CHANGE_PAYMENT_STATE')">
                <v-btn @click="action('approve')" v-show="status === 'PENDING' || status === 'STAGING'" color="primary"
                       style="float: right">
                    Approve
                </v-btn>
            </div>
            <div v-if="hasPermission('MANAGE_TRANSACTION')">
                <v-btn :disabled="status !== 'PENDING' && status !== 'STAGING'" color="error"
                       @click="transactionDialog = true">Transactions
                </v-btn>
            </div>
        </div>
        <div>
            <v-container>
                <report :id="$route.params.id" @status="updateStatus"></report>
            </v-container>
        </div>
        <v-dialog v-model="transactionDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="transactionDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Add Transaction</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <div>
                    <transactions></transactions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Report from "@/components/accounting/Report";
    import LoadingComponent from "@/components/LoadingComponent";
    import Transactions from "@/views/accounting/Transactions";

    export default {
        name: "Payment",
        title: "Payment",
        components: {Transactions, LoadingComponent, Report},
        data() {
            return {
                status: null,
                transactionDialog: false,
                loading: false,
                required: [
                    v => !!v || 'Required field'
                ],
                valid: false
            };
        },
        methods: {
            updateStatus(status) {
                this.status = status;
            },
            action(status) {
                let obj = {payment_id: this.$route.params.id};
                this.loading = true;
                this.axios.put(`payment/${status}`, obj)
                    .then((res) => this.status = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>